import {
  GridColDef,
  GridColumnGroupingModel,
  GridValidRowModel,
} from '@mui/x-data-grid-premium'
import { Box } from '@mui/material'
import { PanelSiteDataType, PanelTableProps } from './EditProduction.types'
import { useMemo, useRef } from 'react'
import { innerTableReduce, roundNumber } from './helperMethods'
import {
  panelContentTableColumns,
  panelTableColumnGrouping,
} from './Column.definintion'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium'

export const PanelContentTable = ({
  data,
  row,
  updateProposedProductionAmountFromInnerTable,
  weeks,
}: PanelTableProps) => {
  const gridApiRef = useRef<GridApiPremium | null>(null)

  const PanelContentTableColumns: GridColDef[] = useMemo(() => {
    return panelContentTableColumns(weeks)
  }, [data])

  const panelDataGroupingModel: GridColumnGroupingModel = useMemo(() => {
    return panelTableColumnGrouping(weeks)
  }, [data])

  const processRowUpdate = (newRow: GridValidRowModel) => {
    const week: string = weeks.find(
      (week: string) => newRow[`${week}_proposedArrivalAmount`] !== undefined
    ) as string
    const proposedArrivalAmount =
      parseFloat(newRow[`${week}_proposedArrivalAmount`]) ?? 0
    newRow[week].proposedArrivalAmount = proposedArrivalAmount
    delete newRow[`${week}_proposedArrivalAmount`]
    if (newRow[week]) {
      const proposedArrivalAmount = newRow[week].proposedArrivalAmount ?? 0
      const initialArrivalAmount = newRow[week].initialArrivalAmount ?? 0
      newRow[week].changeInArrivalAmount = roundNumber(
        proposedArrivalAmount - initialArrivalAmount
      )

      newRow = innerTableReduce(newRow as PanelSiteDataType, weeks)
      const calculatedOuterTableProposedProductionAmount = roundNumber(
        sumChangeInArrivalAmount(
          newRow[week].changeInArrivalAmount,
          newRow.id,
          week
        ) + row[week].initialProductionAmount
      )

      setTimeout(() => {
        updateProposedProductionAmountFromInnerTable(
          calculatedOuterTableProposedProductionAmount,
          row.id,
          week,
          { ...newRow } as PanelSiteDataType
        )
      }, 1000)
    }

    return newRow
  }

  const sumChangeInArrivalAmount = (
    changeInArrivalAmount: number,
    rowId: string | number,
    week: string
  ) => {
    if (!gridApiRef.current) return changeInArrivalAmount
    const rowModels = gridApiRef.current.getRowModels()
    const rowsArray = Array.from(rowModels.values())
    return rowsArray.reduce((acc: number, row: GridValidRowModel) => {
      if (row.id === rowId) {
        // We are not adding the site we have already changed.
        return acc
      }
      return acc + parseFloat(row[week].changeInArrivalAmount)
    }, changeInArrivalAmount)
  }

  return (
    <Box
      id="#table-container-mui"
      margin={2}
      sx={{
        '& .MuiDataGrid-cell--editable': {
          backgroundColor: '#CBD5E1',
        },
      }}
    >
      <BaseTable
        data={data ?? []}
        columns={PanelContentTableColumns as ExtendedGridColDef[]}
        isLoading={false}
        updateTableData={() => {}} // Handled by processRow
        processRow={processRowUpdate}
        uploadData={() => {}} // Not used
        isUploading={false}
        isSaving={false}
        checkBoxSelection={false}
        showTableToolBar={false}
        columnGroupingModel={panelDataGroupingModel}
        hideFooter={true}
        apiRefCallback={(apiRef) => {
          gridApiRef.current = apiRef.current
        }}
        downloadFileName="PanelContentTable"
      />
    </Box>
  )
}
